import React, { FC, useState } from "react";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { IconButton, Menu, MenuItem } from "@mui/material";

import { ArchiveProject } from "@/model/Archive/ArchivedProjectsRequest";

interface PdfMenuProps {
	row: ArchiveProject;
	pdfColor: string;
}

export const PdfMenu: FC<PdfMenuProps> = ({ row, pdfColor }) => {
	const [pdfMenu, setPdfMenu] = useState(null);
	const openPdfMenu = Boolean(pdfMenu);

	const handlePdfMenu = (event: any) => {
		setPdfMenu(event.currentTarget);
	};

	return (
		<>
			<IconButton onClick={handlePdfMenu}>
				<PictureAsPdfIcon sx={{ color: pdfColor }} />
			</IconButton>
			<Menu
				open={openPdfMenu}
				onClose={() => setPdfMenu(null)}
				anchorEl={pdfMenu}
			>
				<MenuItem onClick={() => setPdfMenu(null)}>
					<a href={row.Link} target="_blank" rel="noreferrer">
						Preview
					</a>
				</MenuItem>
				<MenuItem onClick={() => setPdfMenu(null)}>
					<a href={row.Link} download target="_blank" rel="noreferrer">
						Download
					</a>
				</MenuItem>
			</Menu>
		</>
	);
};
